import {
  DocumentFormField,
  DocumentFormFieldWithConditionalVisibility,
} from '~/core/shared/types';

export const isFieldWithConditionalVisibility = (
  field: DocumentFormField | DocumentFormFieldWithConditionalVisibility,
): field is DocumentFormFieldWithConditionalVisibility =>
  !!field.meta?.conditionalVisibility;
